import { useRef } from 'react';

import { ComponentWithViewTracking } from '../../helpers/analytics';
import type { EventType } from '../../helpers/analytics';
import { Box } from '../Box';
import type { BoxProps } from '../Box';

/**
 * Container component for tracking components
 */
export const TrackableContainer = ({
  analyticsName,
  trackImpression,
  eventName,
  ...props
}: {
  /**
   * Name of the component event type for analytics
   */
  eventName: EventType;
} & BoxProps) => {
  const ref = useRef(null);

  const Component = <Box ref={ref} {...props} />;

  if (analyticsName && trackImpression) {
    return (
      <ComponentWithViewTracking
        Component={Component}
        analyticsName={analyticsName}
        eventName={eventName}
        ref={ref}
      />
    );
  }

  return Component;
};
